//#region src/v2/features/localization/locales/zh-cn.ts
/** Built-in API Client translations for zh-cn. */
var zhCn = {
	"serverVariablesSelect": { "selected": "已选择：" },
	"serverVariablesTextbox": { "value": "值" },
	"sidebarListElementForm": { "cancel": "取消" },
	"requestBlock": {
		"authentication": "身份验证",
		"variables": "变量",
		"cookies": "Cookie",
		"headers": "请求头",
		"queryParameters": "查询参数",
		"queryString": "查询字符串",
		"queryStringDescription": "此参数提供完整的查询字符串，因此无法添加其他命名参数。现有命名参数将在其后发送；重复的键会被保留。",
		"requestBody": "请求体",
		"requestName": "请求名称",
		"label": "请求：{name}"
	},
	"responseBlock": {
		"requestFailed": "请求失败",
		"networkErrorHelp": "可能的原因包括 CORS 限制或网络连接问题。请查看浏览器控制台了解详情。如果 CORS 阻止了请求，请配置 API 服务器以允许此来源，或使用可信的代理。",
		"response": "响应",
		"requestHeaders": "请求头",
		"responseHeaders": "响应头",
		"body": "正文"
	},
	"codeInput": {
		"required": "必填",
		"exitHint": "按 {escape}，然后按 {tab} 退出"
	},
	"codeInputLite": { "required": "必填" },
	"dataTableInput": {
		"clearValue": "清除值",
		"showPassword": "显示密码",
		"hidePassword": "隐藏密码"
	},
	"dataTableInputSelect": {
		"value": "值",
		"addValue": "添加值"
	},
	"confirmationForm": {
		"cancel": "取消",
		"save": "保存"
	},
	"collapsibleSection": {
		"collapsed": "（已折叠）",
		"item": "项",
		"items": "项"
	},
	"modalClientContainer": { "label": "API 客户端" },
	"serverDropdown": {
		"server": "服务器：",
		"addServer": "添加服务器",
		"updateServers": "更新服务器",
		"unknownServer": "未知服务器"
	},
	"sidebar": { "search": "搜索" },
	"sidebarMenu": { "settings": "设置" },
	"sidebarToggle": {
		"hide": "隐藏侧边栏",
		"show": "显示侧边栏"
	},
	"environmentsList": { "addEnvironment": "添加环境" },
	"modal": { "noDocumentSelected": "未选择文档" },
	"operation": { "selectAnOperationToViewDetails": "选择一个操作以查看详情" },
	"header": {
		"operationSettings": "操作设置",
		"closeClient": "关闭客户端"
	},
	"openApiClientButton": { "openAPIClient": "打开 API 客户端" },
	"requestBody": {
		"noBody": "无请求体",
		"delete": "删除",
		"selectFile": "选择文件",
		"multipartForm": "多部分表单",
		"formUrlEncoded": "URL 编码表单",
		"binaryFile": "二进制文件",
		"other": "其他",
		"none": "无"
	},
	"requestBodyStructured": { "body": "正文" },
	"requestBodyViewToggle": {
		"form": "表单",
		"raw": "原始内容",
		"fixBody": "修正请求体以切换到表单视图"
	},
	"requestCodeSnippet": {
		unavailable: "此示例暂无可用的代码示例。",
		"codeSnippet": "代码片段"
	},
	"requestTable": {
		"enabled": "已启用",
		"key": "键",
		"value": "值"
	},
	"requestTableRow": {
		"key": "键",
		"value": "值",
		"delete": "删除",
		"selectFile": "选择文件",
		"globalCookieHint": "全局 Cookie 在整个工作区中共享。点击前往查看。",
		"readOnlyHint": "此属性为只读。若要更改，请覆盖该属性或通过复选框禁用它。",
		"include": "在请求中包含 {name}",
		"keyLabel": "{name} 的键",
		"valueLabel": "{name} 的值",
		"deleteRow": "删除 {name}",
		"row": "行"
	},
	"requestTableTooltip": {
		"min": "最小值：",
		"max": "最大值：",
		"default": "默认值：",
		"invalid": "输入无效",
		"moreInformation": "更多信息"
	},
	"headers": {
		"headerKey": "头部键",
		"headerValue": "头部值",
		"noHeaders": "无头部"
	},
	"responseBody": { "binaryFile": "二进制文件" },
	"responseBodyPreview": { "previewUnavailable": "无法预览" },
	"responseBodyStreaming": {
		"body": "正文",
		"listening": "正在监听…",
		"cancel": "取消"
	},
	"responseBodyToggle": {
		"preview": "预览",
		"raw": "原始内容"
	},
	"responseBodyVirtual": {
		"body": "正文",
		"largeBodyHint": "此响应体过大，无法进行语法高亮。"
	},
	"responseCookies": {
		"cookies": "Cookie",
		"cookieName": "Cookie 名称",
		"cookieValue": "Cookie 值",
		"noCookies": "无 Cookie"
	},
	"responseEmpty": {
		"roadmap": "路线图",
		"poweredByScalarcom": "由 Scalar.com 提供支持",
		"getStarted": "开始使用",
		"newRequest": "新建请求",
		"sendRequest": "发送请求",
		"version": "Scalar App V{version} 测试版"
	},
	"responseLoadingOverlay": { "cancel": "取消" },
	"addressBar": {
		"path": "路径",
		"copyUrl": "复制 URL",
		"send": "发送",
		"sendRequest": "向 {url} 发送 {method} 请求",
		"duplicateRequest": "此文档中已存在发往 {path} 的 {method} 请求",
		"urlPlaceholder": "输入 URL",
		"webhookUrlPlaceholder": "输入完整的 Webhook URL，例如 https://example.com/hook"
	},
	"addressBarHistory": { "requestHistory": "请求历史" },
	"environmentSelector": {
		"noEnvironment": "无环境",
		"notAvailableInThisContext": "在此上下文中不可用",
		"environmentHint": "环境可帮助您管理不同上下文中的变量，例如 API 密钥和基础 URL。",
		"add": "添加环境",
		"select": "选择环境",
		"unavailable": "{name}（不可用）",
		"current": "当前环境：{name}"
	},
	"deleteRequestAuthModal": {
		"deleteSecurityScheme": "删除安全方案",
		"cancel": "取消",
		"delete": "删除",
		"confirmation": "此操作无法撤销。您即将从集合中删除安全方案 {name}。"
	},
	"oauth2": {
		deviceAuthorizationUrl: "设备授权 URL",
		deviceVerificationPrompt: "打开验证页面并输入此代码：",
		waitingForAuthorization: "正在等待授权…",
		cancelDeviceAuthorization: "取消",
		"accessToken": "访问令牌",
		"refreshUrl": "刷新 URL",
		"refresh": "刷新",
		"authUrl": "身份验证 URL",
		"tokenUrl": "令牌 URL",
		"redirectUrl": "重定向 URL",
		"username": "用户名",
		"password": "密码",
		"clientID": "客户端 ID",
		"clientSecret": "客户端密钥",
		"usePKCE": "使用 PKCE",
		"credentialsLocation": "凭据位置",
		"authorize": "授权",
		"clear": "清除",
		"failedToauthorize": "授权失败",
		"failedToRefreshToken": "刷新令牌失败",
		"optionalRedirectUrl": "可选的重定向 URL"
	},
	"oauthScopesAddModal": {
		"name": "名称：",
		"description": "描述：",
		"readUserData": "读取用户数据",
		"edit": "编辑权限范围",
		"add": "添加权限范围",
		"save": "保存",
		"required": "权限范围名称为必填项。",
		"duplicate": "名为“{name}”的权限范围已存在。"
	},
	"oauthScopesInput": {
		"noScopesDefined": "未定义权限范围",
		"addScope": "添加权限范围",
		"deselectAll": "取消全选",
		"selectAll": "全选",
		"selectedScopes": "已选权限范围：{count} / {total}",
		"editScope": "编辑 {name}",
		"deleteScope": "删除 {name}",
		"selectScope": "选择权限范围 {name}"
	},
	"openIdConnect": {
		"discoveryUrl": "发现 URL",
		"fetchConfiguration": "获取配置",
		"failedToFetchConfiguration": "获取 OpenID Connect 配置失败"
	},
	"requestAuthDataTable": { "noauthenticationSelected": "未选择身份验证" },
	"requestAuthTab": {
		"token": "令牌",
		"bearerToken": "Bearer 令牌",
		"getAToken": "获取令牌",
		"refresh": "刷新",
		"username": "用户名",
		"password": "密码",
		"name": "名称",
		"value": "值",
		"cancel": "取消",
		"authorize": "授权",
		"unsupportedCredentials": "浏览器客户端不会发送此 AsyncAPI 安全方案的凭据。",
		"authorizeVia": "通过 {name} 授权",
		"unsupportedType": "暂不支持 {type} 类型的安全方案。",
		"missingType": "安全方案缺少类型，请检查您的 {type} 文档或身份验证配置。",
		"failedToauthorize": "授权失败",
		"failedToRefresh": "刷新失败",
		"configure": "配置 {name}",
		"mutualTlsHint": "双向 TLS 通过在 TLS 握手期间提供客户端证书来进行身份验证，因此无需在此输入任何内容。"
	},
	"commandActionForm": { "continue": "继续" },
	"environment": {
		"thisIsTheActiveEnvironment": "这是当前启用的环境",
		"active": "已启用",
		"editEnvironment": "编辑环境",
		"deleteEnvironment": "删除环境"
	},
	"environmentCreateModal": {
		"environmentName": "环境名称",
		"thisEnvironmentNameIsAlreadyInUse": "此环境名称已被使用。",
		"update": "更新环境",
		"add": "添加环境"
	},
	"environmentDeleteModal": {
		"cancel": "取消",
		"deleteEnvironment": "删除环境",
		"deleteConfirmation": "确定要删除此环境吗？此操作无法撤销。",
		"title": "删除 {name}"
	},
	"environmentVariablesDropdown": {
		"variableSuggestions": "变量建议",
		"addVariable": "添加变量"
	},
	"environmentVariablesTable": {
		"name": "名称",
		"value": "值",
		"actions": "操作",
		"environmentVariableName": "环境变量名称",
		"environmentVariableValue": "环境变量值"
	},
	"documentSearchModal": {
		"documentSearch": "文档搜索",
		"documentSearchResults": "文档搜索结果",
		"navigate": "↑↓ 导航",
		"select": "⏎ 选择",
		"keyboardInstructions": "按上箭头或下箭头导航，按回车选择，输入文本筛选结果"
	},
	"searchResult": {
		"httpMethod": "HTTP 方法：",
		"path": "路径：",
		"description": "描述：",
		"heading": "标题",
		"operation": "操作",
		"tag": "标签"
	},
	"sectionFilter": {
		"all": "全部",
		"auth": "身份验证",
		"variables": "变量",
		"cookies": "Cookie",
		"headers": "头部",
		"query": "查询",
		"body": "正文"
	},
	"requestParams": {
		"clearAll": "清除所有{title}",
		"clear": "清除",
		"clearOptionalParameters": "清除可选参数"
	},
	"responseBodyDownload": {
		"download": "下载响应体",
		"label": "下载",
		"body": "响应体"
	},
	"responseMetaInformation": {
		"duration": "响应信息，耗时：",
		"size": "，大小：",
		"status": "，状态："
	},
	"authSelector": {
		"selectedType": "已选身份验证类型：{type}",
		"multipleTypes": "已选择多个身份验证类型",
		"selectType": "选择身份验证类型",
		"optional": "可选",
		"required": "必填",
		"deleteScheme": "删除 {name}",
		"requiredGroup": "必需的身份验证",
		"availableGroup": "可用的身份验证",
		"addGroup": "添加身份验证"
	},
	"operationBlock": {
		"webhookUrlRequired": "Webhook URL 为必填项。请先输入目标地址。",
		"pathParametersRequired": "路径参数必须有值。",
		"forbiddenMethod": "Fetch API 无法发送 {method} 请求。"
	},
	"dataTableCheckbox": { "toggle": "切换" },
	"pillTooltipHost": {
		"computedAtExecution": "在执行请求时计算",
		"noValue": "无值"
	},
	"authOptions": {
		oauth2DeviceAuthorization: "OAuth2 设备授权",
		"apiKeyCookie": "Cookie 中的 API 密钥",
		"apiKeyHeader": "请求头中的 API 密钥",
		"apiKeyQuery": "查询参数中的 API 密钥",
		"httpBasic": "HTTP Basic",
		"httpBearer": "HTTP Bearer",
		"oauth2Implicit": "OAuth2 隐式流程",
		"oauth2Password": "OAuth2 密码流程",
		"oauth2ClientCredentials": "OAuth2 客户端凭据",
		"oauth2AuthorizationFlow": "OAuth2 授权码"
	},
	"deleteSidebarListElement": { "delete": "删除 {name}" },
	"deleteModal": { "delete": "删除 {name}" }
};
//#endregion
export { zhCn };

//# sourceMappingURL=zh-cn.js.map